export enum NodeEnvironment {
  dev = 'development',
  prod = 'production',
}

export enum LaunchdarklyEnvironment {
  test = 'test',
  prod = 'prod',
}
